// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** St. Kitts & Nevis */
const KN: PhoneNumberData = [1, 'KN', 10, format0, /^(?:869)/];

export default KN;
